<template>
  <el-drawer
    title="上传素材"
    :visible.sync="dialogVisible"
    size="1000px"
    append-to-body
    :before-close="handleClose"
  >
    <div class="p-[20px] h-full">
      <el-upload
        ref="upload"
        class="w-full"
        drag
        action="#"
        :accept="acceptType"
        :multiple="limit > 1"
        :auto-upload="false"
        :show-file-list="false"
        :on-change="handleUploadChange"
        :on-exceed="handleExceed"
      >
        <div class="w-full h-full py-[80px] text-center flex flex-col items-center justify-center">
          <i
            class="el-icon-upload text-[40px] text-gray-400 mb-4"
            style="font-size: 40px"
          ></i>
          <div class="text-gray-600 mb-6">
            <p>
              <span class="mr-1">将文件拖拽到此处，或<span class="text-[#409EFF]">点击上传</span></span>
            </p>
          </div>
        </div>
      </el-upload>
      <div class="text-[#ff4d4f] text-[13px]">
        提示：
        <span
          >选择{{ type == 'image' ? '图片' : type == 'logo' ? '徽标' : '视频' }}超过{{ limit }} 个，自动截取前{{
            limit
          }}个</span
        >
      </div>
      <div v-if="type == 'image'" class="text-[13px] leading-7 text-[#666]">
        每个广告最多支持 20 张 <br />
        **横向图片 (1.91:1)**： 最小尺寸：600x314。推荐尺寸：1200x628 文件大小上限：5MB <br />
        **方形图片 (1:1)**： 最小尺寸：300x300。推荐尺寸：1200x1200 文件大小上限：5MB <br />
        **纵向图片 (4:5)**：最小尺寸：480x600。推荐尺寸：960x1200 文件大小上限：5MB 推荐用于除 YouTube Shorts
        外的所有渠道 <br />
        **纵向图片(9:16)**： 最小尺寸：600x1067。推荐尺寸：1080x1920 文件大小上限：5MB 推荐用于 YouTube Shorts <br />
        建议：每种宽高比各上传 3 张图片，以尽可能提高展示位置覆盖率。 注意：接受 GIF 文件类型，但仅显示静态版本。 <br />
      </div>
      <div v-if="type == 'video'" class="text-[13px] leading-7 text-[#666]">
        Shorts 短视频：最长 1 分钟，建议 10-20 秒 <br />
        横向格式：无时长上限，建议不超过 3 分钟<br />
        方形格式：无时长上限，建议不超过 3 分钟 <br />
        横向格式：16:9。高清推荐像素：1920x1080<br />
        方形格式：1:1。高清推荐像素：1080 x 1080 <br />
        纵向格式：4:5 <br />
        竖屏格式：9:16。高清推荐像素：1080x1920 <br />
        格式：MPG（MPEG-2或 MPEG-4） 文件大小：≤256 GB
      </div>
      <div v-if="type == 'logo'" class="text-[13px] leading-7 text-[#666]">Logo图片：1:1 最小尺寸：128x128 格式为PNG或JPEG，大小不超过5MB</div>

      <!-- 不符合规则的图片展示区域 -->
      <div
        v-if="type === 'logo' && invalidImages.length > 0"
        class="mt-6"
      >
        <div class="text-gray-700 text-base mb-4">以下图片尺寸不符合要求，点击进行裁剪：</div>
        <div class="flex">
          <div
            v-for="(img, index) in invalidImages"
            :key="index"
            class="relative cursor-pointer border border-gray-200 rounded-lg hover:border-blue-500 transition-colors w-24 h-24 m-2"
            @click="cropImage(img, index)"
          >
            <el-image
              :src="img.url"
              class="w-24 h-24 object-cover"
              fit="cover"
            />
            <div
              class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity"
            >
              <span class="text-white text-sm">点击裁剪</span>
            </div>
            <i
              class="el-icon-circle-close text-red-500 text-lg absolute -top-1 -right-1 bg-white rounded-full cursor-pointer hover:text-red-600"
              @click.stop="removeInvalidImage(index)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'DragUploadDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'image',
    },
    limit: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      invalidImages: [],
      processedFiles: [], // 记录已处理的文件
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    acceptType() {
      if (this.type === 'image' || this.type === 'logo') {
        return '.png,.jpeg,.jpg';
      } else if (this.type === 'video') {
        return '.mp4';
      }
      return '';
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.resetUpload();
        });
      }
    },
  },
  methods: {
    resetUpload() {
      this.invalidImages = [];
      this.processedFiles = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    handleClose() {
      this.resetUpload();
      this.dialogVisible = false;
    },
    handleUploadChange(file, fileList) {
      // 只处理新增的文件，避免重复处理
      const newFiles = fileList
        .map((item) => item.raw)
        .filter(f => !this.processedFiles.includes(f));
      
      if (newFiles.length > 0) {
        this.processedFiles.push(...newFiles);
        this.processFiles(newFiles);
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上传${this.limit}个文件`);
    },
    processFiles(files) {
      const limitedFiles = files.slice(0, this.limit);

      if (files.length > this.limit) {
        this.$message.warning(`最多只能上传${this.limit}个文件，已自动选择前${this.limit}个`);
      }

      this.$emit('files-selected', limitedFiles);
      
      // 对于logo类型，需要等待父组件处理完文件后再决定是否关闭弹窗
      if (this.type === 'logo') {
        // 延迟检查，给父组件时间处理文件并调用addInvalidImage
        setTimeout(() => {
          if (this.invalidImages.length === 0) {
            this.dialogVisible = false;
          }
        }, 100);
      } else {
        this.$nextTick(() => {
          this.dialogVisible = false;
        });
      }
    },
    addInvalidImage(file) {
      this.invalidImages.push({
        file,
        url: URL.createObjectURL(file),
        name: file.name,
      });
    },
    removeInvalidImage(index) {
      this.invalidImages.splice(index, 1);
    },
    cropImage(img, index) {
      this.$emit('crop-image', img.file);
      this.removeInvalidImage(index);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-upload {
  width: 100%;
  height: 400px;
}
::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
}
</style>
